<table
  mat-table
  [dataSource]="dataSource()"
  matSort
  matSortActive="usage"
  matSortDirection="desc"
  class="no-hover"
>
  <!-- id column -->
  <ng-container matColumnDef="projectId">
    <th mat-header-cell *matHeaderCellDef mat-sort-header="projectId">
      {{ translations.projectId.text }}
    </th>
    <td mat-cell *matCellDef="let row">
      {{ row.projectId }}
    </td>
  </ng-container>

  <!-- name column -->
  <ng-container matColumnDef="projectName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header="projectName">
      {{ translations.projectName.text }}
    </th>
    <td mat-cell *matCellDef="let row">
      <a
        target="_blank"
        class="hover:text-trimble-blue hover:underline"
        [href]="row.projectUrl"
        [modus-tooltip]="translations.projectLink.tooltip.text"
      >
        @if (row.isProjectMember) {
          {{ row.projectName }}
        } @else {
          [{{ translations.notMember.text }}]
        }
      </a>
    </td>
  </ng-container>

  <!-- usage column -->
  <ng-container matColumnDef="usage">
    <th mat-header-cell *matHeaderCellDef mat-sort-header="usage">
      {{ translations.usage.text }}
    </th>
    <td mat-cell *matCellDef="let row">
      {{ row.usage | fileSize }}
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
